import React, { useState } from 'react';
import { Box, Menu, MenuItem, ListItemText } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/sharp-regular-svg-icons';
import TaskPriorityChip from '../TaskPriorityChip/TaskPriorityChip';
import { tasksPriorities } from '../../constant';

type EditableTaskPriorityChipProps = {
    taskPriority?: number;
    onPriorityChange?: (newPriority: number) => void;
    disabled?: boolean;
    compact?: boolean;
};

const EditableTaskPriorityChip: React.FunctionComponent<EditableTaskPriorityChipProps> = function ({
    taskPriority,
    onPriorityChange,
    disabled = false,
    compact = false,
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const isEditable = Boolean(onPriorityChange && !disabled);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        if (isEditable) {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => setAnchorEl(null);

    const handleSelect = (newPriority: number) => {
        if (onPriorityChange && newPriority !== taskPriority) {
            onPriorityChange(newPriority);
        }
        handleClose();
    };

    const chevron = isEditable ? (
        <FontAwesomeIcon
            icon={faChevronDown}
            style={{
                fontSize: '10px',
                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-in-out',
                color: 'currentColor',
            }}
        />
    ) : undefined;

    return (
        <>
            <Box
                onClick={handleClick}
                sx={{ display: 'inline-flex', cursor: isEditable ? 'pointer' : 'default' }}
            >
                <TaskPriorityChip
                    taskPriority={taskPriority}
                    endAdornment={chevron}
                    compact={compact}
                />
            </Box>
            {isEditable && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    PaperProps={{ sx: { minWidth: 130, mt: 0.5 } }}
                >
                    {tasksPriorities.map((priority) => (
                        <MenuItem
                            key={priority.value}
                            selected={taskPriority === priority.value}
                            onClick={() => handleSelect(priority.value)}
                            sx={{ py: 1 }}
                        >
                            <ListItemText
                                primary={priority.label}
                                primaryTypographyProps={{ fontSize: '14px' }}
                            />
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </>
    );
};

export default EditableTaskPriorityChip;
